import { Authenticator } from "@aws-amplify/ui-vue"
import "@aws-amplify/ui-vue/styles.css"

import { Amplify } from 'aws-amplify'

function userpool_client_id() {
  if (window.location.host.includes('localhost')) {
    return '5dfj6nk3s9ast9ve1uajv8tk2f'
  }
  return '7p66rjj2ucvoad4c3kpkhcnf6e'
}

function userpool_id() {
  if (window.location.host.includes('localhost')) {
    return 'eu-central-1_aKRAAPoMx'
  }
  return 'eu-central-1_b7ZVQ1awB'
}

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolClientId: userpool_client_id(),
      userPoolId: userpool_id(),
      loginWith: {
        username: false,
        email: true,
      }
    }
  }
})

export default Authenticator
